import { sql } from "drizzle-orm";
import { pgTable, text, uuid, timestamp, integer, jsonb, index } from "drizzle-orm/pg-core";
import { createInsertSchema, createSelectSchema } from "drizzle-zod";

// ============================================================================
// RESEARCH MODULE TABLES (2 tables)
// ============================================================================

// 1. Research Queries (stores all AI research queries with results)
export const researchQueries = pgTable("crm_x_research_queries", {
  id: uuid("id").primaryKey().default(sql`gen_random_uuid()`),
  queryType: text("query_type").notNull(),
  queryText: text("query_text").notNull(),
  provider: text("provider").notNull(),
  resultSummary: text("result_summary"),
  resultData: jsonb("result_data"),
  sources: jsonb("sources"),
  tokensUsed: integer("tokens_used"),
  durationMs: integer("duration_ms"),
  createdAt: timestamp("created_at").defaultNow().notNull(),
  createdBy: uuid("created_by"),
}, (table) => [
  index("idx_research_queries_type").on(table.queryType),
  index("idx_research_queries_created").on(table.createdAt),
]);

// 2. Research Entity Links (many-to-many linking research to CRM entities)
export const researchEntityLinks = pgTable("crm_x_research_entity_links", {
  id: uuid("id").primaryKey().default(sql`gen_random_uuid()`),
  researchQueryId: uuid("research_query_id").notNull().references(() => researchQueries.id, { onDelete: "cascade" }),
  entityType: text("entity_type").notNull(),
  entityId: uuid("entity_id").notNull(),
  relevance: text("relevance"),
  createdAt: timestamp("created_at").defaultNow().notNull(),
}, (table) => [
  index("idx_research_entity_links_entity").on(table.entityType, table.entityId),
  index("idx_research_entity_links_query").on(table.researchQueryId),
]);

// ============================================================================
// ZOD SCHEMAS
// ============================================================================

export const insertResearchQuerySchema = createInsertSchema(researchQueries).omit({
  id: true,
  createdAt: true,
});

export const selectResearchQuerySchema = createSelectSchema(researchQueries);

export const insertResearchEntityLinkSchema = createInsertSchema(researchEntityLinks).omit({
  id: true,
  createdAt: true,
});

export const selectResearchEntityLinkSchema = createSelectSchema(researchEntityLinks);

// ============================================================================
// TYPES
// ============================================================================

export type ResearchQuery = typeof researchQueries.$inferSelect;
export type InsertResearchQuery = typeof researchQueries.$inferInsert;
export type ResearchEntityLink = typeof researchEntityLinks.$inferSelect;
export type InsertResearchEntityLink = typeof researchEntityLinks.$inferInsert;
